import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=36262360&scoped=true"
import script from "./appMain.vue?vue&type=script&lang=js"
export * from "./appMain.vue?vue&type=script&lang=js"
import style0 from "./appMain.vue?vue&type=style&index=0&id=36262360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36262360",
  null
  
)

export default component.exports